import React from 'react';
import '../styles/Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>MEGATON</h3>
            <p>Serviços Profissionais de Munck & Guindaste</p>
            <p>Seu parceiro confiável para soluções de içamento pesado</p>
          </div>

          <div className="footer-section">
            <h4>Serviços</h4>
            <ul>
              <li>Locação de Munck</li>
              <li>Operações com Guindaste</li>
              <li>Transporte de Equipamentos Pesados</li>
              <li>Suporte para Construção</li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Informações de Contato</h4>
            <p>📱 Telefone: {process.env.REACT_APP_PHONE_NUMBER}</p>
            <p>📍 Localização: Rondonópolis, MT</p>
            <p>⏰ Atendimento Emergencial 24h</p>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} MEGATON. Todos os direitos reservados.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
